<template>
  <div class="login-body">
    <div id="login">
      <div class="row">
        <div class="col col-12 text-center">
          <img src="/dist/img/logo-samen-fris.png" alt="SamenFris logo" />
        </div>
      </div>

      <!-- Unsupported‑browser warning -->
      <div v-if="isUnsupportedBrowser" class="row">
        <div class="col col-2"></div>
         <div class="col col-8">
           Deze internetbrowser van Microsoft en voldoet niet meer aan de nieuwste beveiligingseisen waar Samen Fris aan moet voldoen.
           <br>
           <br>
           De voorkeursbrowser voor het werken met Samen Fris is een recente versie van Google Chrome. Dan werkt Samen Fris het best. Maar ook de recente versies van Mozilla Firefox of Safari worden ondersteund.
        </div>
        <div class="col col-2"></div>
      </div>

      <!-- Login form -->
      <form v-else id="reg-form" @submit.prevent="submitted">
        <div class="form-row">
          <div class="form-group col-md-4">
            <input
              type="text"
              id="username"
              class="form-control"
              placeholder="E‑mail"
              v-model.trim="userData.username"
              autocomplete="username" />
          </div>
          <div class="form-group col-md-4">
            <input
              type="password"
              id="password"
              class="form-control"
              placeholder="Wachtwoord"
              v-model.lazy="userData.password"
              autocomplete="current-password" />
          </div>
          <div class="form-group col-md-4">
            <button type="submit" class="btn btn-primary" :disabled="connecting">
              <span v-if="!connecting">Log in</span>
              <span v-else>Even geduld…</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col col-12 text-center">
            <img v-if="connecting" class="loading" src="/dist/img/loading.gif" />
            <div id="msg" class="msg-response">{{ msg }}</div>
          </div>
        </div>
      </form>

      <br />
      <a
        target="_blank"
        class="forgot"
        href="https://samenfris.nl/wp/wp-login.php?action=lostpassword"
        >Wachtwoord vergeten?</a
      >
      <br />
      <div style="text-align: center">
        Ondervindt u problemen met inloggen?<br />
        Neem dan contact op via
        <a target="_blank" href="mailto:helderopschool@trimbos.nl"
          >helderopschool@trimbos.nl</a
        >.
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import browserDetect from "vue-browser-detect-plugin";
Vue.use(browserDetect);

export default {
  name: "Login",
  data() {
    return {
      userData: {
        username: "",
        password: "",
      },
      msg: "",
      teachersClass: [],
      isUnsupportedBrowser: false,
      connecting: false,
    };
  },

  mounted() {
    this.checkBrowser();

    // If there is a cached token, validate it immediately.
    const tk = localStorage.getItem("token");
    if (tk) {
      this.validateToken(tk);
    }
  },

  methods: {
    /**
     * Detect legacy IE / old Edge and block login form.
     */
    checkBrowser() {
      const bd = this.$browserDetect;
      this.isUnsupportedBrowser = bd.isIE || bd.isEdgeLegacy; // Edge Chromium is fine
    },

    /**
     * Validate an existing JWT – if invalid, wipe it so the user sees the login form.
     */
    validateToken(tk) {
      const options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: "Bearer " + tk,
        },
        url: `${Vue.prototype.$hostname}/wp/wp-json/jwt-auth/v1/token/validate`,
      };
      this.axios(options)
        .then(() => {
          // Token still good – proceed to dashboard.
          this.setLoggedData();
        })
        .catch((err) => {
          const status = err?.response?.status;
          if (status === 401 || status === 403) {
            localStorage.removeItem("token");
            this.msg = "Uw sessie is verlopen. Log alstublieft opnieuw in.";
          } else {
            this.msg = "Netwerkfout. Probeer het opnieuw.";
          }
        });
    },

    /**
     * Fetch current user → decide where to route next.
     */
    setLoggedData() {
      this.axios
        //.get(`${Vue.prototype.$hostname}/wp/wp-json/wp/v2/users/me`, {
        .get(`${Vue.prototype.$hostname}/wp/wp-json/custom/v1/me`, {



          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        .then(({ data }) => {
          if (!data?.id) throw new Error("User data not found");
          return data;
        })
        .then((user) => {
          if (user.roles?.includes("teacher")) {
            localStorage.setItem("role", "teacher");
            localStorage.setItem("userID", user.id);
            localStorage.setItem("parentID", user.user_parent_id || "");
            localStorage.setItem("userNiceName", user.name);
            localStorage.setItem("teacherEmail", user.email);
            this.teacherHasClass(user.id);
          } else {
            alert(
              "U probeert als beheerder in te loggen op het lerarenportaal. U wordt doorgestuurd naar de beheeromgeving."
            );
            window.location.href =
              "https://samenfris.nl/wp/wp-login.php?redirect_to=https%3A%2F%2Fsamenfris.nl%2Fwp%2Fwp-admin%2F&reauth=1";
          }
        })
        .catch((error) => {
          console.error("Error fetching user data: ", error);
          this.msg = error.message || "Er ging iets mis. Probeer opnieuw.";
          localStorage.removeItem("token");
        });
    },

    /**
     * After successful /users/me, fetch the teacher’s class.
     */
    teacherHasClass(teacherId) {
      this.axios
        .get(
          `${Vue.prototype.$hostname}/wp/wp-json/wp/v2/classes?author=${teacherId}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        )
        .then(({ data }) => {
          if (data?.length) {
            this.$emit("authenticated", true);
            this.$router.replace({ path: `/tijdslijn/${data[0].id}` });
          } else {
            this.$emit("authenticated", true);
            this.$router.replace({ name: "page1" });
          }
        })
        .catch((err) => {
          console.error("Class fetch failed", err);
          this.msg = "Er ging iets mis bij het ophalen van je klas.";
          localStorage.removeItem("token");
        });
    },

    /**
     * Submit handler – obtain a new JWT.
     */
    submitted() {
      if (!this.userData.username || !this.userData.password) {
        this.msg = "E‑mail en wachtwoord zijn verplicht.";
        return;
      }

      this.connecting = true;
      this.msg = "";

      this.axios
        .post(`${Vue.prototype.$hostname}/wp/wp-json/jwt-auth/v1/token/`, {
          username: this.userData.username,
          password: this.userData.password,
        })
        .then(({ data }) => {
          localStorage.setItem("token", data.token);
          localStorage.setItem("userDisplayName", data.user_display_name);
        })
        .then(() => this.validateToken(localStorage.getItem("token")))
        .catch((err) => {
          const status = err?.response?.status;
          if (status === 401 || status === 403) {
            this.msg = "Onjuiste e‑mail of wachtwoord.";
          } else {
            this.msg = "Netwerkfout. Probeer het opnieuw.";
          }
          localStorage.removeItem("token");
          localStorage.removeItem("userDisplayName");
            localStorage.removeItem("role");
            localStorage.removeItem("userID");
            localStorage.removeItem("numberOfLicences");
            localStorage.removeItem("numberOfClasses");
            localStorage.removeItem("parentID");
        })
        .finally(() => {
          this.connecting = false;
        });
    },
  },
};
</script>

<style scoped>
.login-body {
  position: absolute;
  inset: 0;
  width: 100vw;
  height: 100vh;
  background: #fff;
}

#login {
  width: 500px;
  margin: 200px auto 0;
  padding: 20px;
}

.loading {
  width: 26%;
}

.btn {
  width: 100%;
}

a.forgot {
  display: block;
  text-align: center;
}
</style>
